
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useTranslation } from "react-i18next";

export const useZodiacSign = (birthdate?: string | null) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: ['zodiac-sign', birthdate],
    queryFn: async () => {
      if (!birthdate) {
        return null;
      }
      
      const { data, error } = await supabase
        .rpc('get_zodiac_sign', { birth_date: birthdate });

      if (error) {
        console.error('Error fetching zodiac sign:', error);
        return null;
      }

      return data?.[0] || null;
    },
    enabled: !!birthdate,
    staleTime: 24 * 60 * 60 * 1000, // Cache for 24 hours since zodiac signs don't change
  });
};

export const getZodiacDisplayName = (zodiacData: any, language: string) => {
  if (!zodiacData) {
    return null;
  }
  return language === 'en' ? zodiacData.name_en : zodiacData.name;
};
